import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { EstudoListComponent } from './estudo-list.component';
import { EstudoListRoutingModule } from './estudo-list.routes';
import { DataPipe } from '../util/data.pipe';

/** AngularMaterial **/
import { MatSelectModule, MatButtonModule, MatIconModule, MatInputModule, MatRadioModule,
  MatProgressBarModule, MatSnackBarModule, MatTabsModule, MatCheckboxModule, MatTableModule,
  MatPaginatorModule, MatSortModule, MatCardModule, MatBadgeModule, MatMenuModule } from '@angular/material';
import { PagerComponent} from '../paginator/pager.component';
import { EstudoService } from '../estudo/estudo.service';
import { EstudoListFiltroComponent } from './estudo-list-filtro.component';
import { DesclassificarModule } from '../desclassificar/desclassificar.module';
import { EmailEstudoModule } from '../email-estudo/email-estudo.module';
import { ObservacaoEstudoModule } from '../observacao-estudo/observacao-estudo.module';
import { ApplicationPipesModule } from '../util/application.pipes.modules';
@NgModule({
    declarations: [
      EstudoListComponent,
      EstudoListFiltroComponent
    ],
    exports: [
      EstudoListComponent,
      EstudoListFiltroComponent
    ],
    imports: [
      FormsModule, CommonModule, ApplicationPipesModule, 
      MatSelectModule, MatButtonModule, MatIconModule, MatInputModule, MatProgressBarModule, MatBadgeModule,
      MatSnackBarModule, MatRadioModule, MatTabsModule, MatSortModule, MatCheckboxModule, MatTableModule, MatPaginatorModule, MatCardModule, MatMenuModule,
      EstudoListRoutingModule, DesclassificarModule, ObservacaoEstudoModule, EmailEstudoModule
    ],
    providers: [
      EstudoService, PagerComponent
    ]
})
export class EstudoListModule {

}
